import type React from 'react';
import { useEffect, useState } from 'react';

interface LazyBackgroundProps {
  src: string;
  className: string;
  children?: React.ReactNode;
}

const TRANSPARENT_PNG_BASE64 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const LazyBackground: React.FC<LazyBackgroundProps> = ({
  src,
  className,
  children,
}) => {
  const [source, setSource] = useState(TRANSPARENT_PNG_BASE64);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setSource(src);
  }, [src]);

  return (
    <div className={className} style={{ backgroundImage: `url(${source})` }}>
      {children}
    </div>
  );
};

export default LazyBackground;
